import { routes } from 'scripts/routes'
import { matchRoutes } from 'react-router-config'
import { locale } from './langs'
import Constants from 'scripts/base/Constants'

if (typeof window !== 'undefined' && routes) {
  const { match } = matchRoutes(routes, window.location.pathname)[0]
  locale.setLanguage(match.params['lang'] || Constants.DefaultLang)
}

export default locale



// WEBPACK FOOTER //
// ./i18n/react.js